<template>
  <ServiceCard 
    title="AWS Migration"
    subtitle="Seamless cloud transition"
    description="Migrate your applications and infrastructure to AWS with minimal downtime and maximum efficiency."
    to="/services/aws-migration"
    gradient-start="#48bb78"
    gradient-end="#38a169"
    
    button-text="Learn More"
  />
</template>

<script setup>
import ServiceCard from '~/components/ServiceCard.vue';
</script>